<template>
    <div>
        <button class="btn btn-sm btn-confirm" @click="onClick">{{ t('Run') }}</button>
        <span v-if="success" class="glyphicon glyphicon-thumbs-up progress-up"></span>
        <span v-if="false === success" :title="errors" class="glyphicon glyphicon-thumbs-down progress-down"></span>
    </div>
</template>

<script>

export default
{
    components: {},
    props: {
        config: {
            type: Object,
        },
        routeName: {
            type: String
        },
        row: {
            type: Object,
        }
    },
    data() {
        return {
            errors: null,
            success: null,
        };
    },
    computed: {
        isActive() {
            return true;
        }
    },
    mounted() {
    },
    methods: {
        onClick() {
            let url = this.config.url;
            let matched = this.config.url.match(/{.*}/g);
            matched.forEach(m => {
               let rowIndex = m.match(/[a-z]+/g)[0];
               url = url.replace(m, this.row[rowIndex]);
            });

            this.$http({
                url: this.routeName + url,
                method: this.config.method
            }).then((response) => {
                if (!response.data.success) {
                    this.errors = response.data.errors.toString();
                }
                this.success = response.data.success;
            });
        }
    }
}
</script>

<style lang="sass">
    .mark-disabled {
        opacity: 0.4!important;
    }
</style>


// WEBPACK FOOTER //
// RunScenarioComponent.vue?268e42bc